import { render, staticRenderFns } from "./UserOverviewPage.vue?vue&type=template&id=5c202f9a&scoped=true"
import script from "./UserOverviewPage.vue?vue&type=script&lang=js"
export * from "./UserOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./UserOverviewPage.vue?vue&type=style&index=0&id=5c202f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c202f9a",
  null
  
)

export default component.exports